// extracted by mini-css-extract-plugin
export default {"mask":"WpExchangeResult_mask__4y7Sv","containerStyle":"WpExchangeResult_containerStyle__3ydhB","wp_exchange_result_box":"WpExchangeResult_wp_exchange_result_box__5ilrW"};